<div class="spinner-container">
  <mat-progress-spinner
    color="accent"
    [diameter]="diameter"
    [strokeWidth]="strokeWidth"
    mode="indeterminate"
  ></mat-progress-spinner>
</div>
